"use strict";
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFest25Graphic = void 0;
var config = __importStar(require("./config.ts"));
var state = __importStar(require("./state.ts"));
var dom = __importStar(require("./domElements.ts"));
var imageManager_ts_1 = require("./imageManager.ts");
var eventHandlers_ts_1 = require("./eventHandlers.ts");
var canvasManager_ts_1 = require("./canvasManager.ts");
var animationManager_ts_1 = require("./animationManager.ts");
var mockCursorManager_ts_1 = require("./mockCursorManager.ts");
function initFest25Graphic() {
    dom.setCanvas(document.getElementById("mainCanvas"));
    if (!dom.canvas) {
        return;
    }
    var tempCtx = dom.canvas.getContext("2d", {
        willReadFrequently: true
    });
    if (!tempCtx) {
        console.error("Failed to get 2D context from canvas.");
        return;
    }
    dom.setCtx(tempCtx);
    // Initialize offscreen base layer canvas
    var offscreenBaseCanvas = document.createElement("canvas");
    var offscreenBaseCtx = offscreenBaseCanvas.getContext("2d", {
        willReadFrequently: true
    });
    if (offscreenBaseCtx) {
        state.setBaseLayerCanvas(offscreenBaseCanvas);
        state.setBaseLayerCtx(offscreenBaseCtx);
    }
    else {
        console.error("Failed to create offscreen canvas context for base layer.");
    }
    (0, canvasManager_ts_1.resizeCanvas)();
    var defaultImageUrl = state.isMobileLayout
        ? config.MOBILE_IMAGE_URL
        : config.DESKTOP_IMAGE_URL;
    (0, imageManager_ts_1.loadImageFromUrl)(defaultImageUrl);
    state.setCurrentColorPalette(__spreadArray([], config.DEFAULT_PALETTE, true));
    state.setSweepPauseEndTime(performance.now() + config.SWEEP_PAUSE_DURATION_MS);
    // Set initial delays
    var now = performance.now();
    state.setInitialCursorVisibilityDelayEndTime(now + config.INITIAL_CURSOR_VISIBILITY_DELAY_MS);
    state.setInitialFlowerCreationDelayEndTime(now +
        config.INITIAL_CURSOR_VISIBILITY_DELAY_MS +
        config.ADDITIONAL_FLOWER_CREATION_DELAY_MS);
    (0, mockCursorManager_ts_1.initializeOrUpdateMockUsers)();
    window.addEventListener("resize", canvasManager_ts_1.resizeCanvas);
    dom.canvas.addEventListener("mousemove", eventHandlers_ts_1.handleCanvasMouseMove);
    dom.canvas.addEventListener("mouseleave", eventHandlers_ts_1.handleCanvasMouseLeave);
    dom.canvas.addEventListener("click", eventHandlers_ts_1.handleCanvasClick);
    (0, animationManager_ts_1.startAnimation)();
}
exports.initFest25Graphic = initFest25Graphic;
